import { Row, Col, ListGroup, Alert } from "react-bootstrap";

import React, { Component } from "react";
import styled from "styled-components";

const Styledalert = styled(Alert)`
  margin: 20px;
  padding: 0px;
  border-style: solid;
  border-color: white;
  border-width: thin;
  background-color: #999999;
`;

class Resources extends Component {
  render() {
    return (

        
      <Styledalert variant="secondary" >
        <Row >

          <Col sm={12} md={4} style={{ marginLeft: "10px", marginBottom: "10px", color: "white"}}>
          <h2>Events</h2>
            <ListGroup>
              <ListGroup.Item>
              <a
                  target="_blank"Add commentMore actions
                  rel="noreferrer"
                  href="https://www.dialysistech.net/aws/NANT/pt/sp/dtx"
                >
                  DTX43, Presented by NANT ~ Las Vegas ~ March 10-13, 2026
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
              <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.asn-online.org/education/kidneyweek/"
                >
                  Kidney Week, Hosted by ASN ~ Denver, CO ~ October 21-25, 2026
                </a>
              </ListGroup.Item>
            </ListGroup>
          </Col>
          <Col sm={12} md={4} style={{ borderStyle: "none none none solid", borderColor: "white", borderWidth: "thick", color: "white"}}>
          <h2>Resources</h2>
            <ListGroup>
            <ListGroup.Item >
                <a target="_blank" rel="noreferrer" href="https://www.nipro.com/usa">
                  NIPRO Medical Corporation USA
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://dialysistechnical.freeforums.net/"
                >
                  Dialysis Discussion Forum
                </a>
              </ListGroup.Item>


              <ListGroup.Item>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.davita.com"
                >
                  DaVita Kidney Care
                </a>
              </ListGroup.Item>
            </ListGroup>
          </Col>
          <Col sm={12} md={3}>
          <h2 class="noVisibilityThing">.</h2>
            <ListGroup>
              <ListGroup.Item>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.dialysistech.net"
                >
                  NANT
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.bridgeoflifeinternational.org"
                >
                  Bridge of Life
                </a>
              </ListGroup.Item>

              <ListGroup.Item>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.campnotawheeze.org"
                >
                  Camp-Not-A-Wheeze
                </a>
              </ListGroup.Item>
            </ListGroup>
            <br/>
          </Col>
        </Row>
      </Styledalert>
    );
  }
}

export default Resources;
